<template>
  <div class="signStatistics-wrap">
    <div v-show="!showHistory" class="wp">
      <div class="s-top">
        <h1 class="com-title com-ht">
          <i></i>已开通服务数：{{ useSetMealList.length }}
        </h1>
        <div style="padding-right: 20px">
          <span class="second_red_btn" @click="showHistory = true">
            历史数据
          </span>
          <!-- <span
            class="first_red_btn"
            v-if="accountInfoVO.rechargeButton === 1"
            @click="toByPoint"
          >去充值
          </span
          > -->
        </div>
      </div>

      <div class="box">
        <el-collapse v-model="activeName" accordion>
          <!--有数据-->
          <el-collapse-item
            v-for="(item, index) in useSetMealList"
            :key="index"
            :name="item.assetItem + '-' + index"
          >
            <div slot="title" class="cp-title">
              <div
                style="
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                "
              >
                <img :src="getTypeIcon(item.assetItem)" alt="" />

                <el-tooltip effect="dark" placement="bottom-start">
                  <div
                    slot="content"
                    v-html="$utils.transferFormat(item.assetName, 16)"
                  ></div>
                  <span style="width: 150px; margin-left: 0">{{
                    item.assetName
                  }}</span>
                </el-tooltip>

                <span style="width: 122px; margin-left: 20px"
                  >套餐总量：{{ tolTalCnt(item.totalCnt) }}</span
                >
                <el-tooltip effect="dark" placement="bottom">
                  <div slot="content">{{ item.usedCnt }}</div>
                  <span style="width: 154px">使用量：{{ item.usedCnt }}</span>
                </el-tooltip>

                <span style="width: 250px"
                  >有效期：
                  <template v-if="item.startTime || item.expireTime">
                    {{ item.startTime | formatT }} 至
                    {{ item.expireTime | formatT }}
                  </template>
                  <template v-else>不限制</template>
                </span>
              </div>
              <span
                v-if="
                  item.totalCnt &&
                  (authUser.userType === 1 || currentAuthUser.corpUserId) && showFlag
                "
                @click.stop="transferFn(item)"
                >转赠</span
              >
            </div>
            <!-- 详情看板 -->
            <recordBoard :isCurr="`${item.assetItem}-${index}` === activeName" :row="item"></recordBoard>
          </el-collapse-item>
          <!--无数据-->
          <no-data text="暂无数据" v-if="!useSetMealList.length"></no-data>
        </el-collapse>
      </div>
    </div>

    <!--历史数据-->
    <div v-show="showHistory" class="wp">
      <div class="s-top">
        <h1 class="com-title com-ht"><i></i>历史数据</h1>
        <span style="padding-right: 20px"
          ><el-button type="danger" @click="showHistory = false"
            >返回</el-button
          ></span
        >
      </div>
      <div class="box">
        <!--有数据-->
        <div
          class="list-one"
          v-for="(item, index) in historyDataList"
          :key="index"
        >
          <img :src="getTypeIcon(item.assetItem)" alt="" />{{ item.assetName }}
          <el-tooltip effect="dark" placement="bottom-start">
            <div
              slot="content"
              v-html="
                $utils.transferFormat(item.assetTitle || item.assetName, 16)
              "
            ></div>
            <span class="tc-name">套餐名称：{{ item.assetTitle }}</span>
          </el-tooltip>

          <!--<span style="width: 50px;">已关闭</span>-->
          <!--<span style="width: 122px;">套餐总量：{{tolTalCnt(item.totalCnt)}}</span>-->
          <span style="width: 108px">使用量：{{ item.usedCnt }}</span>
          <span style="width: 250px"
            >有效期：
            <template v-if="item.startTime || item.expireTime">
              {{ item.startTime | formatT }} 至 {{ item.expireTime | formatT }}
            </template>
            <template v-else>不限制</template>
          </span>
        </div>
        <!--无数据-->
        <no-data text="暂无数据" v-if="!historyDataList.length"></no-data>
      </div>
    </div>
    <!-- 转赠窗口   -->
    <el-dialog
      title="转赠套餐"
      :visible.sync="transferVisible"
      :close-on-click-modal="false"
      width="30%"
      :rules="transferFormRules"
      class="by_name_dialog"
    >
      <el-form
        ref="transferForm"
        label-width="140px"
        :model="transferData"
        :rules="transferFormRules"
      >
        <el-form-item label="转赠套餐项">
          <el-input
            placeholder=""
            v-model="chooseTransferData.assetName"
            :readonly="true"
          />
        </el-form-item>
        <el-form-item label="转赠账号" prop="transferTo">
          <el-input
            placeholder="请输入转赠账号"
            v-model="transferData.transferTo"
          />
        </el-form-item>
        <el-form-item label="转赠次数" prop="transferCount">
          <el-input
            type="text"
            maxlength="9"
            placeholder="请输入转赠次数"
            min="0"
            v-model="transferData.transferCount"
          />
        </el-form-item>
        <el-form-item
          label="转赠套餐有效期"
          prop="expireTime"
          v-if="!chooseTransferData.expireTime"
        >
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="transferData.expireTime"
            :picker-options="datePickerOptions"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="submitLoading" @click="transferVisible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="transferSubmitFn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import recordBoard from "./components/accounRecord/recordBoard.vue";
import ChartsLine from "../../components/charts/charts-line-new";
import EntPackageStat from "../../assets/js/http-serve/entPackageStat";
import { aWeekTimes, monthTimes } from "../../assets/js/lib/common";
import moment from "moment";
import { mapGetters } from "vuex";
import { configUrl } from "../../assets/js/http-serve/http-methods";
import { isInDingTalk } from "../../assets/js/utils/ding-env";
import { isCorp } from "@/assets/js/utils/others";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";

export default {
  components: { ChartsLine,recordBoard },
  data () {
    return {
      PageLoading:false,
      activeName:'',
      //转赠
      submitLoading: false,
      transferVisible: false,
      transferData: {},
      chooseTransferData: {}, //转赠项
      datePickerOptions: {
        disabledDate (time) {
          return time.getTime() <= Date.now();
        },
      },
      transferFormRules: {
        transferTo: [
          {
            required: true,
            validator: this.$validator.required,
            trigger: "change",
            message: "请输入转赠账号",
          },
          { validator: this.$validator.mobileOrEmail, trigger: "change" },
        ],
        transferCount: [
          {
            required: true,
            validator: this.$validator.required,
            trigger: "change",
            message: "套餐数不能为空"
          },
          { validator: this.$validator.integer, trigger: "change" }
        ],
        expireTime: [
          {
            required: true,
            validator: this.$validator.required,
            trigger: "change",
            message: "日期不能为空"
          },
          // {
          //   validator: this.$validator.lengthRank,
          //   trigger: "change",
          //   minLength: 6,
          //   maxLength: 6,
          //   message: "输入6位验证码"
          // }
        ]
      },
      showHistory: false,
      useSetMealList: [], // 当前使用套餐
      historyDataList: [], // 历史数据-过期关闭等的数据
    };
  },
  computed: {
    ...mapGetters(["allAuthUser", "currentAuthUser", "authUser"]),
    accountInfoVO () {
      if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
        return this.allAuthUser.accountInfoVO;
      }
      return {};
    },
    showFlag(){
      const {packageRegiftFlag} = this.currentAuthUser
      return (packageRegiftFlag && packageRegiftFlag ==1) ? true : false
    },
  },
  filters: {
    formatT: function (value) {
      if (!value || value == "") {
        return "不限制";
      }
      return moment(value).format("YYYY-MM-DD");
    }
  },
  mounted () {
    this.getCurrentPkgUse();
    this.queryHistoryPkgList();
  },
  methods: {
    //转赠提交
    transferSubmitFn () {
      this.$refs.transferForm.validate((val) => {
        if (val) {
          this.submitLoading = true;
          ApiCorpMethods.accountOperationController.transferPkgItem({
            assetItem: this.chooseTransferData.assetItem,
            assetName: this.chooseTransferData.assetName,
            pkgId: this.chooseTransferData.id,
            expireTime: this.chooseTransferData.expireTime ? this.chooseTransferData.expireTime : '',
            ...this.transferData,
          }).then(res => {
            this.submitLoading = false;
            if (res.success) {
              this.$message.success('操作成功');
              this.$refs.transferForm.clearValidate();
              this.transferVisible = false;
              this.chooseTransferData = {}; //转赠项
              this.getCurrentPkgUse();
              this.queryHistoryPkgList();
            } else {
              this.$message.error(res.description || '操作失败');
            }
          });
        }

      })
    },
    //转赠按钮
    transferFn (item) {
      this.chooseTransferData = item;
      this.transferData = {};
      this.transferVisible = true;
      this.$nextTick(() => {
        this.$refs.transferForm.clearValidate();
      })
    },
    toByPoint () {
      if (this.allAuthUser.accountInfoVO.rechargeButton === 1) {
        let url = configUrl().accountWeb + "/asset/pointChargePage";
        if (isInDingTalk) {
          url = url + "?dingH5=1";
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          document.body.append(a);
          a.click();
          setTimeout(() => {
            a.remove();
          }, 1000);
        } else {
          window.open(url, "_blank");
        }
      } else {
        this.$alert("请联系供应商充值积分", { confirmButtonText: "确定" });
      }
    },
    // 计算剩余量
    remainCnt (item) {
      if (!item) return "";
      if (+item.totalCnt === 0) {
        // 总量
        return "<span>不限量</span>";
      } else if (item.totalCnt == null) {
        return "<span>没有此套餐</span>";
      } else {
        return item.totalCnt - item.usedCnt;
      }
    },
    // 计算总量
    tolTalCnt (count) {
      if (+count === 0 || count === undefined) {
        // 总量
        return "不限量";
      } else {
        return count;
      }
    },

    // 根据套餐类型生成图标
    getTypeIcon (type) {
      switch (+type) {
        // 签署份数
        case 1:
          return require(`@/static/images/web/signStatistics/icon-s1.png`);

        // 人脸
        case 6:
        case 11:
          return require(`@/static/images/web/signStatistics/icon-s2.png`);

        // 银行卡
        case 3:
        case 4:
        case 24:
          return require(`@/static/images/web/signStatistics/icon-s3.png`);

        // 短信
        case 2:
        case 10:
        case 20:
          return require(`@/static/images/web/signStatistics/icon-s4.png`);

        // 保险
        case 7:
          return require(`@/static/images/web/signStatistics/icon-s5.png`);

        // 其他
        default:
          return require(`@/static/images/web/signStatistics/icon-s6.png`);
      }
    },

    // 获取当前使用套餐
    getCurrentPkgUse () {
      this.loadingStart();
      let params = isCorp() ? { corpQuery: 1 } : {}
      if(isInDingTalk){
        const {dingTalkCorpId:corpId,dingTalkUserId} = JSON.parse(sessionStorage.getItem("dingloginInfo"));
        params = {
          corpId,
          dingTalkUserId
        }
      }
      // corpQuery 1:成员查询企业。其他不传这个参数。
      const PackAPI = isInDingTalk ? dingtalkApi.usableList : EntPackageStat.queryUseAblePkgList
      PackAPI(params)
        .then(result => {
          if (result.success) {
            this.useSetMealList = result.data;
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .catch(err => {
          if (this.$store.getters.authUser.identityAuth > -1) {
            this.$message.warning(err.description || "请求超时，请刷新试一试");
            console.error("当前使用套餐统计：" + JSON.stringify(err));
          }
        }).finally(()=>{this.loadingClose()});
    },
    // 获取历史数据
    queryHistoryPkgList () {
      EntPackageStat.queryHistoryPkgList(isCorp() ? { corpQuery: 1 } : {})
        .then(result => {
          if (result.success) {
            this.historyDataList = result.data;
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .catch(err => {
          if (this.$store.getters.authUser.identityAuth > -1) {
            this.$message.warning(err.description || "请求超时，请刷新试一试");
            console.error("套餐使用历史数据统计：" + JSON.stringify(err));
          }
        });
    },
    /**
     * 查询使用量图表
     * @index 当前查询的图表index
     * @dateType:1:7天,2:30天,3:90天(不包含当天)
     * */
    searchChartData (index = 0, dateType) {
      if (
        this.useSetMealList[index] &&
        this.useSetMealList[index].selectDateType === dateType
      )
        return false; // 时间没变，不查询
      this.$set(this.useSetMealList[index], "selectDateType", dateType); // 当前选择的查询时间
      if (!this.useSetMealList.length) return false;
      let assetItemId = this.useSetMealList[index].assetItem;
      // 构造图表数据
      let cData = {
        // 无数据展示为空
        xAxis: [],
        data: [10] // 来个值渲染图表，不然为空不美观
      };
      let domRf =
        this.$refs[`linechart`] && this.$refs[`linechart`][index]
          ? this.$refs[`linechart`][index]
          : "";
      domRf && domRf.showLoading();
      const data = { assetItemId, dateType };
      if (isCorp()) data.corpQuery = 1
      EntPackageStat.queryAssetItemDayUsedFillZero(data)
        .then(result => {
          if (result.success) {
            if (result.data && result.data.length > 0) {
              cData = {
                // 先清空数据
                xAxis: [],
                data: []
              };
              result.data.map(sub => {
                cData.xAxis.push(sub.day);
                cData.data.push(sub.cnt);
              });
            }
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .catch(err => {
          if (this.$store.getters.authUser.identityAuth > -1) {
            this.$message.warning(err.description || "请求超时，请刷新试一试");
            console.error("查询使用量图表：" + JSON.stringify(err));
          }
        })
        .finally(() => {
          domRf && domRf.hideLoading();
          domRf && domRf.resize();
          this.$set(this.useSetMealList[index], "chartData", cData);
        });
    },
    loadingStart (info = null) {
      this.PageLoading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.PageLoading) {
        this.PageLoading.close();
        this.PageLoading = null;
      }
    },
  },
  name: "signStatistics"
};
</script>

<style lang="less" scoped>
.first_red_btn {
  padding: 2px 10px;
  margin-right: 10px;
  border: 1px solid rgba(236, 28, 28, 1);
  opacity: 1;
  border-radius: 5px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  background-color: rgba(236, 28, 28, 1);
  &:hover {
    background-color: #f26060;
    color: #ffffff;
  }
}
.second_red_btn {
  padding: 2px 10px;
  margin-right: 10px;
  border: 1px solid rgba(236, 28, 28, 1);
  opacity: 1;
  border-radius: 5px;
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: rgba(236, 28, 28, 1);
  cursor: pointer;
  &:hover {
    background-color: rgba(236, 28, 28, 1);
    color: #ffffff;
  }
}
/*改版*/
.signStatistics-wrap {
  background: #ffffff;
  height: 100%;
  /*overflow-y: auto;*/
  overflow-x: hidden;
  /*height: calc(100vh - 340px);*/

  .s-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eeeeee;

    .com-ht {
      border-bottom: none;
    }

    button {
      padding: 5px 10px;
    }
  }

  .wp {
    width: 100%;
  }

  .box {
    width: 100%;
    padding: 25px 20px;
  }

  .cp-title {
    width: 100%;
    font-size: 16px;
    font-family: Source Han Sans SC;
    line-height: 54px;
    color: #290202;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;

    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    span {
      margin-left: 40px;
      color: rgba(41, 2, 2, 0.45);
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:nth-of-type(1) {
        margin-left: 54px;
      }
    }
  }

  /deep/ .el-collapse {
    border: none;

    .el-collapse-item__header {
      border-bottom: none;
    }

    .el-collapse-item__wrap {
      border: none;
    }

    .el-collapse-item {
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      margin-bottom: 15px;
    }
  }

  .list-one {
    width: 100%;
    height: 54px;
    line-height: 54px;
    background: #ffffff;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #290202;
    margin-bottom: 15px;
    box-sizing: border-box;
    padding-right: 13px;

    img {
      width: 30px;
      height: 30px;
      margin-left: 10px;
      margin-right: 10px;
    }

    span {
      font-size: 14px;
      color: rgba(41, 2, 2, 0.45);
      margin-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }

    .tc-name {
      margin-left: 42px;
      width: 196px;
    }
  }

  .noData {
    text-align: center;
    color: rgba(41, 2, 2, 0.45);
    font-size: 14px;
    padding: 30px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/signStatistics.vue